import {
    transcribeIcon, darkTranscribeIcon,
    diarizeIcon, darkDiarizeIcon,
    summarizeResumeIcon, darkSummarizeResumeIcon,
    universalSummarizeResumeIcon, darkUniversalSummarizeResumeIcon,
    depersonalizeFileDataIcon, darkDepersonalizeFileDataIcon,
    retellingIcon, darkRetellingIcon,
    standardControlPSAIcon, darkStandardControlPSAIcon,
    marketPriceAnalysisIcon, darkMarketPriceAnalysisIcon,
    invoiceRecognizerIcon, darkInvoiceRecognizerIcon,
    transcriptIcon, darkTranscriptIcon,
} from '../assets/icons';

export const AI_UTILITIES = {
    TRANSCRIBE: {
        id: 'Transcriber',
        name: 'Преобразование аудиозаписи голоса в текст (транскрибация)',
        path: '/transcribe',
        lightIcon: transcribeIcon,
        darkIcon: darkTranscribeIcon,
        permission: 'transcribe_access',
    },
    DIARIZE: {
        id: 'Diarizer',
        name: 'Составление протокола совещания (диаризация)',
        path: '/diarize',
        lightIcon: diarizeIcon,
        darkIcon: darkDiarizeIcon,
        permission: 'diarize_access',
    },
    SUMMARIZE_RESUME: {
        id: 'SummarizeResume',
        name: 'Резюмирование протокола совещания',
        path: '/summarizeresume',
        lightIcon: summarizeResumeIcon,
        darkIcon: darkSummarizeResumeIcon,
        permission: 'summarize_resume_access',
    },
    UNIVERSAL_SUMMARIZE: {
        id: 'UniversalSummarizeResume',
        name: 'Универсальная суммаризация (техническая)',
        path: '/universalsummarizeresume',
        lightIcon: universalSummarizeResumeIcon,
        darkIcon: darkUniversalSummarizeResumeIcon,
        permission: 'universal_summarize_resume_access',
    },
    DEPERSONALIZE: {
        id: 'DepersonalizeFileData',
        name: 'Обезличивание файловых данных',
        path: '/depersonalize',
        lightIcon: depersonalizeFileDataIcon,
        darkIcon: darkDepersonalizeFileDataIcon,
        permission: 'depersonalize_file_data_access',
    },
    RETELLING: {
        id: 'Retelling',
        name: 'Адаптивное резюмирование и пересказ текста',
        path: '/retelling',
        lightIcon: retellingIcon,
        darkIcon: darkRetellingIcon,
        permission: 'retelling_access',
    },
    STANDARD_CONTROL_PSA: {
        id: 'StandardControlPSA',
        name: 'Нормоконтроль ПСД',
        path: '/standardcontrolpsa',
        lightIcon: standardControlPSAIcon,
        darkIcon: darkStandardControlPSAIcon,
        permission: 'standard_control_psa_access',
    },
    MARKET_PRICE_ANALYSIS: {
        id: 'MarketPriceAnalysis',
        name: 'Конъюктурный анализ цен',
        path: '/marketpriceanalysis',
        lightIcon: marketPriceAnalysisIcon,
        darkIcon: darkMarketPriceAnalysisIcon,
        permission: 'market_price_analysis_access',
    },
    INVOICE_RECOGNIZER: {
        id: 'InvoiceRecognizer',
        name: 'Валидация накладных',
        path: '/invoicerecognizer',
        lightIcon: invoiceRecognizerIcon,
        darkIcon: darkInvoiceRecognizerIcon,
        permission: 'invoice_recognizer_access',
    },
    TRANSCRIPT: {
        id: 'Transcript',
        name: 'Стенограмма',
        url: 'https://transcrib.ghostring.ru/',
        lightIcon: transcriptIcon,
        darkIcon: darkTranscriptIcon,
        permission: 'transcript_access',
    }
};